import axios from "axios";

const URL = {
    base: '/api/cdk/payment/v1',
    sendXClickedToSource: '/send-x-click-to-source/',
}

const HEADERS = {
    "Content-Type": "application/json"
}

const sendXClickedToSource = () => {

    axios.get(`${URL.base}${URL.sendXClickedToSource}`, {headers: HEADERS})
        .then(response => {
            console.log('sendXClickedToSource success ', response);
        })
        .catch(e => {
            console.error('An error has occurred while trying to sendXClickedToSource', e);
        });

}

const CommonService = {
    registerOnUnloadListener: () => {
        console.log('Registering listener');
        window.addEventListener('beforeunload', sendXClickedToSource);
    },
    unregisterOnUnloadListener: () => {
        console.log('Removing listener');
        window.removeEventListener('beforeunload', sendXClickedToSource);
    }
}

export default CommonService;